export default "__VITE_ASSET__plpuV3rL__"